import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import styled from "styled-components";
import { Button } from "react-bootstrap";

import { FcClock } from "react-icons/fc";

import { SearchRadi } from "../../model/staff";

import { UserRight, UserRightChecker } from "../../core/Helper3";
import { RadiSchedulerService } from "../../model/backoffice/df-ratio";
import { FormCheckBlack } from "../../features/RadConnStyle";
import { GetThaiFormatDate, GetThaiZoneDate } from "../../core/Helper";
import { GetEditorForm } from "../../core/Helper2";
import SearchBigData, { DefaultState } from "../components/SearchBigData";

export default function DFRadScheduleEditor(props) {
  const user = useSelector((state) => state.user);
  const [editor, setEditor] = props.editor;
  const [selectData, setSelectData] = useState(null);
  const [selectDele, setSelectDele] = useState([]);
  const [data, setData] = useState([]);

  const [searchBig, setSearchBig] = useState(DefaultState);
  const [form, setForm] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (editor?.show) {
      // console.log(editor);

      loadDateItems();
      // renderForm();
      return () => {
        setSelectData(null);
        setData([]);
        setSelectDele([]);
        setForm(null);
      };
    }
  }, [editor.show]);

  //Calendar Header
  const getHeader = (text, click, dutyId) => {
    return (
      <DutyHeader>
        <span>
          <FcClock size={30} /> {text}
        </span>
        {UserRightChecker(user.userRule, UserRight.CanScheduleRadiologist) ? (
          <Button variant="outline-primary" onClick={() => click(dutyId)}>
            +
          </Button>
        ) : (
          <></>
        )}
      </DutyHeader>
    );
  };

  // ดึงข้อมูลเก่า
  const loadDateItems = async (curDate) => {
    var ret = await RadiSchedulerService.GetDateItems(
      { schedule_date: getEditorDate(curDate) },
      user.detail
    );
    setData(ret ?? []);
    // console.log(ret);
  };

  // เลือกรายการที่ต้องการลบ
  const checkDelete = (checked, item) => {
    if (checked) {
      if (
        selectDele?.filter(
          (r) => r?.DutyType === item.dutyId && r.Staffid === item?.Staffid
        ).length === 0
      ) {
        setSelectDele((pv) => [...pv, item]);
      }
    } else {
      setSelectDele((pv) => [
        ...pv.filter(
          (r) => r?.DutyType !== item.dutyId && r.Staffid !== item?.Staffid
        ),
      ]);
    }
  };

  // สร้าง รายการแสดงบน Calendar
  const getBody = (dutyId) => {
    return (
      <DutyBody>
        {data?.map((item) => {
          return item.DutyType === dutyId ? (
            <FormCheckBlack
              onChange={(e) => {
                checkDelete(e.target.checked, item);
              }}
              label={item?.FullName}
            />
          ) : (
            <></>
          );
        })}
      </DutyBody>
    );
  };

  // สร้าง FORM
  const renderForm = () => {
    setForm(
      <Wrapper>
        <DutyWrapper>
          {getHeader("เวรเช้า", radiologistClick, 1)}
          {getBody(1)}
        </DutyWrapper>
        <DutyWrapper>
          {getHeader("เวรบ่าย", radiologistClick, 2)}
          {getBody(2)}
        </DutyWrapper>
        <DutyWrapper>
          {getHeader("เวรดึก", radiologistClick, 3)}
          {getBody(3)}
        </DutyWrapper>
        {/* <DutyWrapper>
          {getHeader("เวรดึก-2", radiologistClick, 4)}
          {getBody(4)}
        </DutyWrapper> */}
      </Wrapper>
    );
  };

  // REFERSH FROM
  useEffect(() => {
    renderForm();
  }, [data, selectDele]);

  // เพิ่มชื่อแพทย์หลังจากเลือกรายชื่แพทย์
  useEffect(() => {
    if (selectData) {
      for (let key in selectData) {
        let dutyId = Number(key);
        let row = data?.filter(
          (r) =>
            r?.DutyType === dutyId && r.Staffid === selectData[key]?.Staffid
        );
        // วน loop เพื่อเพิ่มข้อมูล
        if (row.length === 0) {
          setData((pv) => [
            ...pv,
            {
              RadScheduleId: 0,
              DutyType: dutyId,
              Staffid: selectData[key]?.Staffid,
              FullName: selectData[key]?.FullName,
            },
          ]);
        }
      }
      setSelectData(null);
    }
  }, [selectData]);

  const radiologistClick = (dutyId) => {
    SearchRadi([
      setSearchBig,
      selectData,
      setSelectData,
      user.detail,
      {
        fieldName: dutyId,
        searchDisplayName: "FullName",
        searchValueName: "Staffid",
      },
    ]);
  };

  const getEditorDate = () => {
    let year = editor?.curDate?.year ?? new Date().getFullYear();
    let month = editor?.curDate?.month ?? new Date().getMonth();
    let day = editor?.item?.da ?? new Date().getDay();
    let date = GetThaiZoneDate(new Date(year, month, Number(day)));
    return date;
  };

  // บันทึก
  const actionSave = async () => {
    // if (IsEmptyArray(data)) {
    //   AlertError("ไม่พบรายชื่อแพทย์เวร", dispatch);
    //   return;
    // }

    let ret = await RadiSchedulerService.Update(
      { data, schedule_date: getEditorDate() },
      user.detail
    );

    if (ret) {
      editor.action(getEditorDate());
    }
  };

  // ยืนยันการลบรายชื่อหมอ
  const clearUnwantedItem = () => {
    let x = data;
    // filter เฉพาะแพทย์ที่ตรงกับเวร
    selectDele?.map((item) => {
      x = x?.filter(
        (r) => !(r?.DutyType === item.DutyType && r.Staffid === item?.Staffid)
      );
    });

    setData(x);
    setSelectDele([]);
  };
  return (
    <>
      <GetEditorForm
        {...{
          title:
            "เลือกแพทย์เวรประจำ " +
            GetThaiFormatDate(
              new Date(
                editor?.curDate?.year ?? new Date().getFullYear(),
                editor?.curDate?.month ?? new Date().getMonth(),
                editor?.item?.da ?? new Date().getDay()
              )
            ),
          form: [form, setForm],
          editor: [editor, setEditor],
          size: "xl",
          saveData: UserRightChecker(
            user.userRule,
            UserRight.CanScheduleRadiologist
          )
            ? actionSave
            : null,
          footerLeft:
            selectDele?.length > 0 &&
            UserRightChecker(
              user.userRule,
              UserRight.CanScheduleRadiologist
            ) ? (
              <Button
                variant="outline-danger"
                onClick={() => clearUnwantedItem()}
              >
                ลบรายการที่เลือก
              </Button>
            ) : (
              <></>
            ),
        }}
      />
      {/* <SearchTypeB {...{ winState: [searchB, setSearchB] }} /> */}
      <SearchBigData {...{ winState: [searchBig, setSearchBig] }} />
    </>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

const DutyWrapper = styled.div`
  display: flex;
  min-height: 300px;
  flex-direction: column;
  background-color: var(--bg-secondary);
  margin-inline: 2px;
  border-radius: 5px;
  justify-content: start;
  color: var(--caption-fore-color);
`;

const DutyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 10px;
  width: 100%;
  align-items: center;
  /* background-color: yellow; */
  border-bottom: 1px solid var(--border-color);
`;
const DutyBody = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 18px;
`;
const PersonContainer = styled.div``;
